module.exports = __webpack_public_path__ + "bac3f7dde26f38f358e67b7d5bd369c2.svg";